module.exports = __webpack_public_path__ + "static/media/shirt.4066319f.png";